import React from "react";
import { Section, Title } from "components/shared";
import { SkillsContainer, Icon } from "./style";
import getIcon from "util/getIcon";

const SKILL_ICONS = [
    "html",
    "css",
    "sass",
    "tailwind",
    "styled-components",
    "javascript",
    "react",
    "github",
    "git",
];

export default function Skills() {
    return (
        <Section id="skills">
            <Title>Skills</Title>
            <SkillsContainer>
                {SKILL_ICONS.map((item) => (
                    <Icon color={item} key={item}>
                        <use href={getIcon(item)} />
                    </Icon>
                ))}
            </SkillsContainer>
        </Section>
    );
}
